export default __webpack_public_path__ + "static/media/tutorial_2.3eef7dde.svg";